import ctl from '@netlify/classnames-template-literals';

export const wrapperStyle = 'center-absolute w-full max-w-[550px]';

export const containerStyle = ctl(`
  p-4
  bg-white 
  rounded-md
`);

export const titleStyle = ctl(`
  mb-4
  text-xl 
  text-center
  font-bold 
`);

export const messageStyle = ctl(`
  font-normal
`);

export const hintStyle = ctl(`
  text-[16px] 
  text-center
`);
